import { AppKind } from "./components/app-kind";
import type { NonUserAppFeatures } from "./components/SerializedApp";
import { getAppKindFromFeatures } from "./components/SerializedApp";
import { getFeatureSetting } from "./feature-settings";

export function isWireApp(features: NonUserAppFeatures | undefined): boolean {
    if (getAppKindFromFeatures(features) === AppKind.Page) return true;
    if (features?.useNCM !== true) return false;
    return getFeatureSetting("appsOnNCM");
}
